<template>
  <div>
    <ProductModal
      v-if="isOpen"
      :isOpen="isOpen"
      :reload="reload"
      :close="modalClose"
    />
    <div class="px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
      <div class="inline-block min-width-full overflow-hidden rounded-lg shadow bg-white p-4">
        <b-row class="my-4 min-width-full align-items-center">
          <b-col md="4">
            <b-input-group>
              <b-form-input
                id="inline-form-input-name"
                class=" mr-sm-2 md-4"
                placeholder="상품명을 입력하세요."
                v-model="search.title"
                v-on:keyup.enter="handleSearch"
              ></b-form-input>
              <b-input-group-append>
                <button class="btn btn-primary" v-on:click="handleSearch">검색</button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col md="3">
            <b-form-checkbox
              v-model="search.checkDeleted"
              v-on:click="handleChangeCheckbox()"
              class="mt-sm"
            >
              삭제상품 같이 보기
            </b-form-checkbox>
          </b-col>
          <b-col class="text-right">
            <button class="btn btn-warning text-white" v-on:click="modalClose">상품 생성</button>
          </b-col>
        </b-row>
        <b-table :fields="fields" :items="products" class="text-left">
          <template #cell(amount)="data">
            {{ `${data.item.amount.toLocaleString()}원`}}
          </template>
          <template #cell(createdAt)="data">
            {{ getDate(data.item.createdAt)}}
          </template>
          <template #cell(button)="data">
            <button v-if="data.item.deletedAt === null" class="btn btn-outline-danger" v-on:click="setDelete(data.item)">삭제</button>
            <span v-if="data.item.deletedAt !== null">{{getDate(data.item.deletedAt)}} 삭제</span>
          </template>
        </b-table>
        <b-pagination
          align="center"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="pageSize"
          @page-click="changePage"
        />
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/api";
import customDate from "@/util/custom-date";
import ProductModal from "@/components/modals/ProductModal.vue";

export default {
  components: {ProductModal},
  data() {
    return {
      products: [],
      currentPage: 1,
      pageSize: 30,
      totalPage: 0,
      totalRows: 0,
      isOpen: false,
      fields: [
        {
          label: '상품명',
          key: 'title',
        },
        {
          label: '가격',
          key: 'amount',
        },
        {
          label: '생성일',
          key: 'createdAt',
        },
        {
          label: '',
          key: 'button',
          thStyle: { width: "20%" },
        }
      ],
      search: {
        title: "",
        checkDeleted: false
      },
    }
  },
  mounted() {
    // URL query params에서 상태 복원
    const query = this.$route.query
    if (query.page) {
      this.currentPage = parseInt(query.page)
    }
    if (query.title) {
      this.search.title = query.title
    }
    if (query.checkDeleted === 'true') {
      this.search.checkDeleted = true
    }
    
    this.getPagingList(this.currentPage)
  },
  methods: {
    modalClose(){
      this.isOpen = !this.isOpen
    },
    reload(){
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    handleSearch() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    handleChangeCheckbox() {
      this.search.checkDeleted = !this.search.checkDeleted
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    updateQueryParams() {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.search.title) {
        query.title = this.search.title
      }
      if (this.search.checkDeleted) {
        query.checkDeleted = 'true'
      }
      
      this.$router.replace({ query })
    },
    getDate(date){
      return customDate.stringFormat(date)
    },
    changePage(event, page){
      this.currentPage = page
      this.updateQueryParams()
      this.getPagingList(this.currentPage)
    },
    setDelete(product){
      this.$store.dispatch('modal/openModal', {
        type: 'warning',
        title: '결제 상품 삭제',
        html: `${product.title}을 삭제합니다. 삭제하는 경우 모든 결제링크의 옵션에서 삭제됩니다.`,
        confirm: () => {
          api.product.setDelete({id: product.id} , () => {
            this.getPagingList(this.currentPage)
          },(err) => {
            console.log(err)
          })
        }
      });
    },
    getPagingList(page) {
      let param = {
        page: page,
        title: this.search.title,
        showDeleted: this.search.checkDeleted
      }
      
      api.product.list(param,(response) => {
        const {content, totalPages, totalElements} = response.data
        this.products = content
        this.totalPage = totalPages
        this.totalRows = totalElements
        this.currentPage = page
      }, (err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
.text-right{
  text-align: right;
}
</style>